import classNames from 'classnames'
import React from 'react'
import './BackgroundBlurCircle.sass'

interface BackgroundBlurCircleProps {
  className?: string
  size: 'small' | 'big'
}

export const BackgroundBlurCircle: React.FC<BackgroundBlurCircleProps> = ({
  className,
  size,
}) => {
  const circlePrfx = 'blur-circle'
  const circleCls = classNames(circlePrfx, {
    [`${circlePrfx}_small`]: size === 'small',
    [`${circlePrfx}_big`]: size === 'big',
    [`${className}`]: className,
  })
  return <div className={circleCls}></div>
}
